export const ADD_FIELD: string = 'ADD_FIELD';
export const ADD_USERS: string = 'ADD_USERS';
export const ADD_STATES: string = 'ADD_STATES';
export const ADD_COUNTRIES: string = 'ADD_COUNTRIES';
export const ADD_TAB: string = 'ADD_TAB';
export const ADD_FORM_TITLE: string = 'ADD_FORM_TITLE';
export const UPDATE_FIELDS: string = 'UPDATE_FIELDS';
export const ADD_ALL_GROUP_USERS = 'ADD_ALL_GROUP_USERS';